import { isAppRunningInDev } from "utils/utils";

// Function to set an item in local storage
export const setLocalStorageItem = (key: string, value: any) => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    if (isAppRunningInDev()) {
      console.error("Error setting item in local storage:", error);
    }
  }
};

// Function to get an item from local storage
export const getLocalStorageItem = <T>(key: string, defaultValue?: T): T | undefined => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return defaultValue;
    }
    return JSON.parse(serializedValue) as T;
  } catch (error) {
    if (isAppRunningInDev()) {
      console.error("Error getting item from local storage:", error);
    }
    return defaultValue;
  }
};

export const setLocalStorageArrayObject = (key: string, objectArrayItem: [] | {}) => {
  try {
    const jsonStringValue = JSON.stringify(objectArrayItem);
    localStorage.setItem(key, jsonStringValue);
  } catch (err) {
    if (isAppRunningInDev()) {
      console.error("Error @setLocalStorageArrayObject:", err);
    }
  }
};

export const setLocalStorageOneItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

export const getLocalStorageOneItem = (key: string) => {
  return localStorage.getItem(key);
};

export const removeLocalStorageOneItem = (key: string) => {
  return localStorage.removeItem(key);
};
